import { useFeatureFlag } from "@shared/services/posthog/use-feature-flag";
import { useHasModule } from "./useHasModule";
import { sidekickModuleEnum } from "./sidekick-modules";

// The `crm` module is the source of truth once a user's profile has it. Some
// users have `crm-v1` enabled ahead of the module being granted, so the flag
// is only consulted as a fallback while the module is absent.
export const useIsCrmEnabled = (): boolean | null => {
  const hasCrmModule = useHasModule(sidekickModuleEnum.CRM);
  const isFlagEnabled = useFeatureFlag("crm-v1");

  if (hasCrmModule) return true;
  return isFlagEnabled;
};
